import React from 'react';
import './styles.css';
import {
  ADMIN,
  ECE,
  TEACHER,
  STUDENT,
  PARENT,
  ASSISTANT,
} from '@BUP/constants';
import { Row, Col, Button } from 'antd';
import { useHistory } from 'react-router-dom';
import { useTranslation } from 'react-i18next';

const SendMessageText = ({ role }) => {
  const history = useHistory();
  const [t] = useTranslation();

  if (role === ECE || role === ADMIN) {
    return (
      <div className="send-message-text-wrapper">
        <div className="bold-text">
          <h2>{t('pages.modeBup.send.sendMessageTextComponent.titleEce')}</h2>
        </div>
        <div className="normal-text">
          <p>
            {t('pages.modeBup.send.sendMessageTextComponent.text1Ece')} <br />
            <br />
            {t('pages.modeBup.send.sendMessageTextComponent.text2Ece')}{' '}
            <span className="word-bold">
              {t('pages.modeBup.send.sendMessageTextComponent.text3EceSpan')}
            </span>{' '}
            {t('pages.modeBup.send.sendMessageTextComponent.text4Ece')}{' '}
            <span className="word-bold">
              {t('pages.modeBup.send.sendMessageTextComponent.text5EceSpan')}
            </span>{' '}
            {t('pages.modeBup.send.sendMessageTextComponent.text6Ece')}
          </p>
        </div>
        <Row style={{ width: '100%' }}>
          <Col
            span={24}
            style={{ display: 'flex', justifyContent: 'space-evenly' }}
          >
            <Button
              size="large"
              style={{ width: '170px', fontWeight: 'bold' }}
              type="primary"
              onClick={() => history.push('/modebup/inbox')}
            >
              {t('pages.modeBup.send.sendMessageTextComponent.textButton1Ece')}
            </Button>
            <Button
              size="large"
              style={{ width: '170px', fontWeight: 'bold' }}
              type="primary"
              onClick={() => history.push('/modebup/archived')}
            >
              {t('pages.modeBup.send.sendMessageTextComponent.textButton2Ece')}
            </Button>
          </Col>
          <Col span={24} style={{ marginTop: 40 }}>
            <div className="normal-text">
              <p>
                <span className="word-bold">
                  {t(
                    'pages.modeBup.send.sendMessageTextComponent.text7EceSpan'
                  )}
                </span>
              </p>
              <p>{t('pages.modeBup.send.sendMessageTextComponent.text8Ece')}</p>
            </div>
          </Col>
        </Row>
      </div>
    );
  }
  if (role === PARENT) {
    return (
      <div className="send-message-text-wrapper">
        <div className="normal-text">
          <p>{t('pages.modeBup.send.sendMessageTextComponent.textParent')}</p>
        </div>
      </div>
    );
  }
  if (role === TEACHER || role === ASSISTANT) {
    return (
      <div className="send-message-text-wrapper">
        <div className="bold-text">
          <h2>
            {t('pages.modeBup.send.sendMessageTextComponent.text1Teacher')}
          </h2>
        </div>
        <div className="normal-text">
          <p>{t('pages.modeBup.send.sendMessageTextComponent.text2Teacher')}</p>
        </div>
      </div>
    );
  }
  if (role === STUDENT) {
    return (
      <div className="send-message-text-wrapper">
        <div className="bold-text">
          <h2>
            {t('pages.modeBup.send.sendMessageTextComponent.text1Student')}
          </h2>
        </div>
        <div className="normal-text">
          <p>{t('pages.modeBup.send.sendMessageTextComponent.text2Student')}</p>
        </div>
      </div>
    );
  }
  return null;
};

SendMessageText.defaultProps = {
  role: 'STUDENT',
};

export default SendMessageText;
